<template>
  <div class="app-container">
    <div class="card">
      <div class="league-selection">
        <a-checkbox
        v-model:checked="leagueSelectAll"
        :indeterminate="leagueSelectionIndeterminate"
        @change="onCheckAllChange"
        >
          全选
        </a-checkbox>
        <div class="league-list">
          <a-row justify="space-between">
            <a-col
              v-for="league in leagues"
              :key="league.leagueId"
            >
              <a-checkbox :value="league.leagueId" :checked="leagueSelected.includes(league.leagueId)" @change="onLeagueSelecttionChange(league.leagueId)">{{ league.leagueName }}</a-checkbox>
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="match-selection">
        <a-select
          v-model:value="selectedMatchId"
          @change="handleMatchChange"
          placeholder="选择比赛"
          style="width: 100%; max-width: 420px"
        >
          <a-select-option value="">选择比赛</a-select-option>
          <a-select-option
            v-for="match in matches"
            :key="match.match_id"
            :value="match.match_id"
          >
            <template v-if="betting_matches.includes(match.match_id)">
              ✓ {{ match.homeTeam }} vs {{ match.awayTeam }} ({{ match.matchTime }})
            </template>
            <template v-else>
              &nbsp;&nbsp;&nbsp;&nbsp;{{ match.homeTeam }} vs {{ match.awayTeam }} ({{ match.matchTime }})
            </template>
          </a-select-option>
        </a-select>
      </div>
    </div>

    <div class="card" v-if="currentOdds">
      <div class="section-title">推荐方案</div>
      <div class="recommendation-buttons">
        <a-button
          v-for="algorithm in algorithms"
          :key="algorithm.id"
          :class="{ 'algo-button--active': selectedAlgoId === algorithm.id }"
          @click="getRecommendation(algorithm.id)"
        >
          {{ algorithm.name }}
        </a-button>
      </div>
    </div>

    <div class="odds-list" v-if="currentOdds">
      <div v-for="(value, key) in currentOdds.odds" :key="key" class="odds-item">
        <label>
          <input type="checkbox"
                 v-model="selectedOddsItems"
                 :value="{ type: key, odds: value }">
          {{ key }} ({{ value }})
        </label>
      </div>
    </div>

    <div v-if="currentOdds" class="odds-grid-section">
      <div class="section-title">赔率表</div>
      <check-table
        :data="tableDataSet"
        :selectedOddsItems="selectedOddsItems"
        @table-selection-change="handleTableSelectionChange"
      />
    </div>

    <div class="card betting-table-section" v-if="selectedOddsItems.length">
      <div class="section-title">投注表 · {{ currentMatch.homeTeam }} vs {{ currentMatch.awayTeam }}</div>
      <div class="action-area">
        <a-input-group compact>
          <a-input-number v-model:value="amountPerOdd" step="10" style="width: 160px" />
          <a-button type="primary" @click="applyMoneyPerOdd">每注金额</a-button>
        </a-input-group>
      </div>

      <div class="table-scroll">
        <table class="bet-table" v-if="selectedOddsItems.length">
          <thead>
            <tr>
              <th>比分</th>
              <th>赔率</th>
              <th>投注</th>
              <th>收益</th>
              <th>收益减成本</th>
              <th>收益率</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in selectedOddsItems" :key="index">
              <td>{{ item.title }}</td>
              <td class="num">{{ item.value }}</td>
              <td>
                <a-input-number v-model:number="bettingAmounts[index]" step="10"  @input="onAmountInput" />
              </td>
              <td class="num">{{ calculateReturn(item.value, bettingAmounts[index]) }}</td>
              <td :class="netClass(item, index)">{{ calculateNetReturn(item.value, bettingAmounts[index]) }}</td>
              <td :class="netClass(item, index)">{{ calculateROI(item.value, bettingAmounts[index]) }}%</td>
            </tr>
            <tr class="total-row">
              <td colspan="2">总计</td>
              <td class="num">{{ totalBetting }}</td>
              <td colspan="3"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="bottom-bar" v-if="selectedOddsItems.length">
      <span class="bar-total">总计 {{ totalBetting }}</span>
      <a-select
        v-if="userId === 1"
        v-model:value="selectedUserId"
        placeholder="选择用户"
        style="width: 120px"
      >
        <a-select-option
          v-for="user in users"
          :key="user.user_id"
          :value="user.user_id"
        >
        {{ user.info }}
        </a-select-option>
      </a-select>
      <a-button type="primary" @click="saveBettingData">保存投注</a-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import CheckboxTable from '../components/CheckboxTable.vue'
import CheckTable from '../components/CheckTable.vue';

export default {
  name: 'Home',
  meta: {
    title: '足彩助手 - 投注'
  },
  components: {
    CheckTable,
    CheckboxTable
  },
  data() {
    return {
      leagueSelectAll: false,
      leagueSelectionIndeterminate: false,
      leagueSelected: [],
      selectedMatchId: '',
      selectedOddsTime: '',
      selectedOddsItems: [],
      selectedAlgoId: null,
      bettingEdited: false,
      selectedUserId: "1",
      bettingAmounts: [],
      amountPerOdd: 100,
      oddNames: {'had':'胜负', 'crsh':'主队胜', 'crsd':'主队平', 'crsa':'主队负', 'ttg':'总进球数', 'hafu':'半全场胜平负'}
    }
  },
  computed: {
    userId() {
      return Number(localStorage.getItem('userId'))
    },
    allMatches() {
      return this.$store.state.matches.list
    },
    matches() {
      return this.$store.state.matches.list.filter(match => this.leagueSelected.includes(match.leagueId));
    },
    betting_matches() {
      return this.$store.state.matches.betting_matches
    },
    leagues() {
      return this.$store.state.matches.leagues
    },
    users() {
      return this.$store.state.matches.users
    },
    algorithms() {
      return this.$store.state.matches.algorithms
    },
    currentMatch() {
      return this.$store.getters['matches/getMatchById'](this.selectedMatchId)
    },
    currentMatchOddsTables() {
      return this.currentMatch?.oddsTables || []
    },
    currentOddsId() {
      return this.currentMatch?.odds_id || 0
    },
    currentOdds() {
      return this.currentMatchOddsTables.find(t => t.publishTime === this.selectedOddsTime)
    },
    totalBetting() {
      return this.bettingAmounts.reduce((sum, amount) => sum + (amount || 0), 0)
    },
    tableDataSet() {
      if (this.currentOdds) {
        return [{"colCount": 3, "odds": this.currentOdds.had, "title": "胜负", "titleColor": "lightgrey"},
                {"colCount":8, "odds": this.currentOdds.crsh, "title": "主队胜", "titleColor": "lightblue"},
                {"colCount":6, "odds": this.currentOdds.crsd, "title": "平", "titleColor": "lightblue"},
                {"colCount":8, "odds": this.currentOdds.crsa, "title": "主队负", "titleColor": "lightblue"},
                {"colCount":4, "odds": this.currentOdds.ttg, "title": "总进球数", "titleColor": "lightgreen"},
                {"colCount":3, "odds": this.currentOdds.hafu, "title": "半全场胜平负", "titleColor": "lightpink"},
              ]
      }
      return []
    }
  },
  methods: {
    async fetchInitialData() {
      await this.$store.dispatch('matches/fetchMatches')
    },
    onCheckAllChange(e) {
      this.leagueSelectAll = e.target.checked;
      if (e.target.checked) {
        this.leagueSelected = this.leagues.map(league => league.leagueId);
      } else {
        this.leagueSelected = [];
      }
      localStorage.setItem('leagueSelected', JSON.stringify(this.leagueSelected));
      this.leagueSelectionIndeterminate = false;
    },
    onLeagueSelecttionChange(value) {
      const index = this.leagueSelected.indexOf(value);
      if (index > -1) {
        this.leagueSelected.splice(index, 1);
      } else {
        this.leagueSelected.push(value);
      }
      localStorage.setItem('leagueSelected', JSON.stringify(this.leagueSelected));
      this.leagueSelectAll = this.leagueSelected.length === this.leagues.length;
      this.leagueSelectionIndeterminate = this.leagueSelected.length > 0 && this.leagueSelected.length < this.leagues.length;
    },
    handleMatchChange() {
      if (this.currentMatch && this.currentMatchOddsTables.length) {
        this.selectedOddsTime = this.currentMatchOddsTables[this.currentMatchOddsTables.length - 1].publishTime
        this.selectedOddsItems = []
        this.bettingAmounts = []
        this.selectedAlgoId = null
        this.bettingEdited = false
      }
    },
    handleOddsChange() {
      this.selectedOddsItems = []
      this.bettingAmounts = []
      this.selectedAlgoId = null
      this.bettingEdited = false
    },
    applyMoneyPerOdd() {
      console.log(this.amountPerOdd, this.selectedOddsItems, this.bettingAmounts);
      for (let [index, odd] of this.selectedOddsItems.entries()) {
        this.bettingAmounts[index] = this.amountPerOdd;
      }
      this.bettingEdited = true;
      this.calculateResults();
    },
    onAmountInput() {
      // 用户手动修改投注金额，标记为已编辑
      this.bettingEdited = true;
      this.calculateResults();
    },
    async getRecommendation(algoId) {
      // 仅当用户手动编辑过投注表时，替换前才确认，避免覆盖手动选择
      if (this.bettingEdited &&
          !window.confirm('当前投注表已手动编辑，应用该算法将覆盖现有选择，是否继续？')) {
        return;
      }
      const data = { userId: this.userId, oddsId: this.currentOddsId, algoId: algoId }
      try {
        const response = await axios.post('https://api.ip008.com/odds/recom.php', data)
        console.log(response.data)
        console.log(this.currentOdds.crsa)
        this.selectedOddsItems = response.data
        this.bettingAmounts = []
        for (let [index, odd] of this.selectedOddsItems.entries()) {
          this.bettingAmounts[index] = odd.amount;
        }
        this.selectedAlgoId = algoId;
        this.bettingEdited = false;
        this.calculateResults();
      } catch (error) {
        console.error('推荐失败:', error)
        alert('推荐失败')
      }
    },
    handleTableData(data) {
      // this.selectedData1 = data;
      this.selectedOddsItems = data;
      console.log(data)
    },
    handleTableSelectionChange(items) {
      this.selectedOddsItems = items;
      this.bettingEdited = true;
      console.log("handleTableSelectionChange", items)
    },
    calculateReturn(odds, amount) {
      return ((odds * amount) || 0).toFixed(2)
    },
    calculateNetReturn(odds, amount) {
      return (((odds * amount) - this.totalBetting) || 0).toFixed(2)
    },
    calculateROI(odds, amount) {
      if (!amount) return '0.00'
      return (((odds * amount - this.totalBetting) / this.totalBetting) * 100).toFixed(2)
    },
    netClass(item, index) {
      const v = parseFloat(this.calculateNetReturn(item.value, this.bettingAmounts[index]))
      return v > 0 ? 'num gain' : (v < 0 ? 'num loss' : 'num')
    },
    calculateResults() {
      this.bettingAmounts = [...this.bettingAmounts]
    },
    async saveBettingData() {
      const bettingData = this.selectedOddsItems.map((item, index) => ({
        odds: item.name,
        amount: this.bettingAmounts[index] || 0
      }))
      const userId = (this.userId === 1) ? this.selectedUserId : this.userId
      const data = { userId: userId, matchId: this.selectedMatchId, oddsId: this.currentOddsId, betting: bettingData }

      try {
        await axios.post('https://api.ip008.com/odds/save.php', data)
        alert('保存成功')
      } catch (error) {
        console.error('保存失败:', error)
        alert('保存失败')
      }
    }
  },
  created() {
    let selectedString = localStorage.getItem('leagueSelected');
    if (selectedString) {
      this.leagueSelected = JSON.parse(selectedString);
    } else {
      this.leagueSelected = [];
    }
    this.fetchInitialData()
  }
}
</script>

<style scoped>
.league-selection {
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid var(--line);
}

.league-list {
  margin-top: 12px;
}

.league-list .ant-row {
  display: flex;
  flex-wrap: wrap;
  margin: -6px;
}

.league-list .ant-col {
  padding: 6px;
}

.league-list .ant-col:nth-child(-n+4) {
  flex: 0 0 25%;
  max-width: 25%;
}

.league-list .ant-col:nth-child(n+5) {
  flex: 0 0 50%;
  max-width: 50%;
}

.match-selection {
  display: flex;
  gap: 16px;
}

.odds-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 8px;
  margin: 16px 0;
}

.odds-item {
  padding: 8px 10px;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  background: var(--surface);
}

.odds-grid-section {
  margin-top: 16px;
}

.action-area {
  margin-bottom: 14px;
}

.recommendation-buttons {
  margin-bottom: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* Active recommendation algorithm — amber "current pick" treatment */
.recommendation-buttons .algo-button--active,
.recommendation-buttons .algo-button--active:hover,
.recommendation-buttons .algo-button--active:focus {
  background-color: var(--pitch-600) !important;
  border-color: var(--pitch-600) !important;
  color: #fff !important;
  font-weight: 600;
  box-shadow: 0 0 0 2px var(--amber-soft), 0 0 0 3px var(--amber);
}

.table-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.bet-table .ant-input-number {
  width: 96px;
}

@media (max-width: 640px) {
  .league-list .ant-col:nth-child(-n+4),
  .league-list .ant-col:nth-child(n+5) {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
</style>
